var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import moment from 'moment';
import { CurrencyTokenSymbol } from '../data/currency-tokens/currency-tokens';
import { appEnv } from '../env';
import { SortDirection, TokenType } from '../types/common';
export function getImxOrders(imxClient, usdcAddress, queue, fees, orders, type, currencyTokens, parsedFilters, orderBy, direction, cursors, remainings, parseCurrencyQuantity, options) {
    return __awaiter(this, void 0, Promise, function () {
        var auxiliaryFee, currentCusors, ctaTokenResponse, usdcResponse, response, result, responses, _a, _b, _c, tokenIds, cardData, _d, cardShredData, _e, supplyData, _f, mappedCards, mintPassData, _g, mappedMintPasses, souvenirCardData, _h, mappedSouvenirCards, newDetailedOrders;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    auxiliaryFee = fees.buyer > 0
                        ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                        : {};
                    currentCusors = (options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : cursors;
                    response = [];
                    result = [];
                    if (!(((options === null || options === void 0 ? void 0 : options.refresh) || (remainings === null || remainings === void 0 ? void 0 : remainings.cta) !== 0) &&
                        ((currencyTokens.length === 1 && currencyTokens.includes(CurrencyTokenSymbol.CTA)) || (remainings === null || remainings === void 0 ? void 0 : remainings.usdc) === 0))) return [3 /*break*/, 2];
                    return [4 /*yield*/, queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenId: options === null || options === void 0 ? void 0 : options.sellTokenId, sellTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? appEnv.ctaTokenAddress : appEnv.blockchain.collectionAddress, sellMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? undefined : JSON.stringify(parsedFilters), buyTokenId: (options === null || options === void 0 ? void 0 : options.buyProps) && (options === null || options === void 0 ? void 0 : options.buyTokenId) ? options.buyTokenId : undefined, buyTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? undefined : appEnv.ctaTokenAddress, buyMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? JSON.stringify(parsedFilters) : undefined, pageSize: (options === null || options === void 0 ? void 0 : options.pageSize) || 200, orderBy: orderBy, direction: direction, cursor: currentCusors.cta, status: (options === null || options === void 0 ? void 0 : options.status) || 'active', sellTokenName: (options === null || options === void 0 ? void 0 : options.sellTokenName) && (options === null || options === void 0 ? void 0 : options.sellTokenName.length) > 0 ? options.sellTokenName : undefined, buyTokenName: (options === null || options === void 0 ? void 0 : options.buyTokenName) && (options === null || options === void 0 ? void 0 : options.buyTokenName.length) > 0 ? options.buyTokenName : undefined, includeFees: true, user: (options === null || options === void 0 ? void 0 : options.user) || undefined }, auxiliaryFee));
                        })];
                case 1:
                    ctaTokenResponse = _j.sent();
                    return [3 /*break*/, 7];
                case 2:
                    if (!(((options === null || options === void 0 ? void 0 : options.refresh) || (remainings === null || remainings === void 0 ? void 0 : remainings.usdc) !== 0) &&
                        ((currencyTokens.length === 1 && currencyTokens.includes(CurrencyTokenSymbol.USDC)) || (remainings === null || remainings === void 0 ? void 0 : remainings.cta) === 0))) return [3 /*break*/, 4];
                    return [4 /*yield*/, queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? usdcAddress : appEnv.blockchain.collectionAddress, sellMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? undefined : JSON.stringify(parsedFilters), buyTokenId: (options === null || options === void 0 ? void 0 : options.buyProps) && (options === null || options === void 0 ? void 0 : options.buyTokenId) ? options.buyTokenId : undefined, buyTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? undefined : usdcAddress, buyMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? JSON.stringify(parsedFilters) : undefined, pageSize: (options === null || options === void 0 ? void 0 : options.pageSize) || 200, orderBy: orderBy, direction: direction, cursor: currentCusors.usdc, status: (options === null || options === void 0 ? void 0 : options.status) || 'active', sellTokenName: (options === null || options === void 0 ? void 0 : options.sellTokenName) && (options === null || options === void 0 ? void 0 : options.sellTokenName.length) > 0 ? options.sellTokenName : undefined, buyTokenName: (options === null || options === void 0 ? void 0 : options.buyTokenName) && (options === null || options === void 0 ? void 0 : options.buyTokenName.length) > 0 ? options.buyTokenName : undefined, includeFees: true, user: (options === null || options === void 0 ? void 0 : options.user) || undefined }, auxiliaryFee));
                        })];
                case 3:
                    usdcResponse = _j.sent();
                    return [3 /*break*/, 7];
                case 4:
                    if (!(((options === null || options === void 0 ? void 0 : options.refresh) || ((remainings === null || remainings === void 0 ? void 0 : remainings.cta) !== 0 && (remainings === null || remainings === void 0 ? void 0 : remainings.usdc) !== 0)) && currencyTokens.length !== 1)) return [3 /*break*/, 7];
                    _b = (_a = Promise).all;
                    _c = [queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? appEnv.ctaTokenAddress : appEnv.blockchain.collectionAddress, sellMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? undefined : JSON.stringify(parsedFilters), buyTokenId: (options === null || options === void 0 ? void 0 : options.buyProps) && (options === null || options === void 0 ? void 0 : options.buyTokenId) ? options.buyTokenId : undefined, buyTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? appEnv.blockchain.collectionAddress : appEnv.ctaTokenAddress, buyMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? JSON.stringify(parsedFilters) : undefined, pageSize: (options === null || options === void 0 ? void 0 : options.pageSize) || 200, orderBy: orderBy, direction: direction, cursor: currentCusors.cta, status: (options === null || options === void 0 ? void 0 : options.status) || 'active', sellTokenName: (options === null || options === void 0 ? void 0 : options.sellTokenName) && (options === null || options === void 0 ? void 0 : options.sellTokenName.length) > 0 ? options.sellTokenName : undefined, buyTokenName: (options === null || options === void 0 ? void 0 : options.buyTokenName) && (options === null || options === void 0 ? void 0 : options.buyTokenName.length) > 0 ? options.buyTokenName : undefined, includeFees: true, user: (options === null || options === void 0 ? void 0 : options.user) || undefined }, auxiliaryFee));
                        })];
                    return [4 /*yield*/, queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? usdcAddress : appEnv.blockchain.collectionAddress, sellMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? undefined : JSON.stringify(parsedFilters), buyTokenId: (options === null || options === void 0 ? void 0 : options.buyProps) && (options === null || options === void 0 ? void 0 : options.buyTokenId) ? options.buyTokenId : undefined, buyTokenAddress: (options === null || options === void 0 ? void 0 : options.buyProps) ? appEnv.blockchain.collectionAddress : usdcAddress, buyMetadata: (options === null || options === void 0 ? void 0 : options.buyProps) ? JSON.stringify(parsedFilters) : undefined, pageSize: (options === null || options === void 0 ? void 0 : options.pageSize) || 200, orderBy: orderBy, direction: direction, cursor: currentCusors.usdc, status: (options === null || options === void 0 ? void 0 : options.status) || 'active', sellTokenName: (options === null || options === void 0 ? void 0 : options.sellTokenName) && (options === null || options === void 0 ? void 0 : options.sellTokenName.length) > 0 ? options.sellTokenName : undefined, buyTokenName: (options === null || options === void 0 ? void 0 : options.buyTokenName) && (options === null || options === void 0 ? void 0 : options.buyTokenName.length) > 0 ? options.buyTokenName : undefined, includeFees: true, user: (options === null || options === void 0 ? void 0 : options.user) || undefined }, auxiliaryFee));
                        })];
                case 5: return [4 /*yield*/, _b.apply(_a, [_c.concat([
                            _j.sent()
                        ])])];
                case 6:
                    responses = _j.sent();
                    ctaTokenResponse = responses[0];
                    usdcResponse = responses[1];
                    _j.label = 7;
                case 7:
                    currentCusors.cta = ctaTokenResponse === null || ctaTokenResponse === void 0 ? void 0 : ctaTokenResponse.cursor;
                    currentCusors.usdc = usdcResponse === null || usdcResponse === void 0 ? void 0 : usdcResponse.cursor;
                    if (ctaTokenResponse)
                        response = __spreadArray(__spreadArray([], response, true), ctaTokenResponse.result, true);
                    if (usdcResponse)
                        response = __spreadArray(__spreadArray([], response, true), usdcResponse.result, true);
                    tokenIds = response.map(function (order) {
                        if (options === null || options === void 0 ? void 0 : options.buyProps) {
                            return order.buy.data.token_id ? Number.parseInt(order.buy.data.token_id) : 0;
                        }
                        return order.sell.data.token_id ? Number.parseInt(order.sell.data.token_id) : 0;
                    });
                    if (!(type === TokenType.CARD)) return [3 /*break*/, 9];
                    return [4 /*yield*/, gqlSdk.CardFindManyByTokenId({ input: { tokenIds: tokenIds } })];
                case 8:
                    _d = _j.sent();
                    return [3 /*break*/, 10];
                case 9:
                    _d = undefined;
                    _j.label = 10;
                case 10:
                    cardData = _d;
                    if (!cardData) return [3 /*break*/, 12];
                    return [4 /*yield*/, gqlSdk.MpCardWithDisenchantPreviewFindMany({ input: { tokenIds: tokenIds } })];
                case 11:
                    _e = _j.sent();
                    return [3 /*break*/, 13];
                case 12:
                    _e = undefined;
                    _j.label = 13;
                case 13:
                    cardShredData = _e;
                    if (!cardData) return [3 /*break*/, 15];
                    return [4 /*yield*/, gqlSdk.MpCardSupplyFindByTokenIds({ input: { tokenIds: tokenIds } })];
                case 14:
                    _f = _j.sent();
                    return [3 /*break*/, 16];
                case 15:
                    _f = undefined;
                    _j.label = 16;
                case 16:
                    supplyData = _f;
                    if (!(options === null || options === void 0 ? void 0 : options.refresh) && orders) {
                        result = __spreadArray([], orders, true);
                    }
                    mappedCards = cardData
                        ? Object.fromEntries(cardData.cardFindManyByTokenId.map(function (curr) { return [curr.tokenId, curr]; }))
                        : undefined;
                    if (!(type === TokenType.MINT_PASS)) return [3 /*break*/, 18];
                    return [4 /*yield*/, gqlSdk.MintPassFindManyByTokenId({ input: { tokenIds: tokenIds } })];
                case 17:
                    _g = _j.sent();
                    return [3 /*break*/, 19];
                case 18:
                    _g = undefined;
                    _j.label = 19;
                case 19:
                    mintPassData = _g;
                    mappedMintPasses = mintPassData
                        ? Object.fromEntries(mintPassData.mintPassFindManyByTokenId.map(function (curr) { return [curr.tokenId, curr]; }))
                        : undefined;
                    if (!(type === TokenType.SOUVENIR_CARD)) return [3 /*break*/, 21];
                    return [4 /*yield*/, gqlSdk.SouvenirCardFindManyByTokenId({ input: { tokenIds: tokenIds } })];
                case 20:
                    _h = _j.sent();
                    return [3 /*break*/, 22];
                case 21:
                    _h = undefined;
                    _j.label = 22;
                case 22:
                    souvenirCardData = _h;
                    mappedSouvenirCards = souvenirCardData
                        ? Object.fromEntries(souvenirCardData.souvenirCardFindManyByTokenId.map(function (curr) { return [curr.tokenId, curr]; }))
                        : undefined;
                    newDetailedOrders = (options === null || options === void 0 ? void 0 : options.buyProps)
                        ? response.map(function (order) {
                            var mappedCard = mappedCards
                                ? mappedCards[order.buy.data.token_id ? Number.parseInt(order.buy.data.token_id) : 0]
                                : undefined;
                            var mappedMintPass = mappedMintPasses
                                ? mappedMintPasses[order.buy.data.token_id ? Number.parseInt(order.buy.data.token_id) : 0]
                                : undefined;
                            var mappedSouvenirCard = mappedSouvenirCards
                                ? mappedSouvenirCards[order.buy.data.token_id ? Number.parseInt(order.buy.data.token_id) : 0]
                                : undefined;
                            var price = parseCurrencyQuantity(order.sell.data.quantity_with_fees, order.sell.data.token_address);
                            var shredPreview = cardShredData
                                ? cardShredData.mpCardWithDisenchantPreviewFindMany.find(function (data) { var _a; return ((_a = data.card.tokenId) === null || _a === void 0 ? void 0 : _a.toString()) === order.buy.data.token_id; })
                                : undefined;
                            var supply = supplyData
                                ? supplyData.mpCardSupplyFindByTokenIds.cards.find(function (data) { var _a; return ((_a = data.tokenId) === null || _a === void 0 ? void 0 : _a.toString()) === order.buy.data.token_id; })
                                : undefined;
                            return {
                                order: order,
                                card: mappedCard,
                                mintPass: mappedMintPass,
                                souvenirCard: mappedSouvenirCard,
                                price: price,
                                shredPreview: shredPreview
                                    ? {
                                        stonesCount: shredPreview.disenchantPreview.stoneEternal,
                                        triselsCount: shredPreview.disenchantPreview.freeGemsCount,
                                    }
                                    : undefined,
                                supply: supply === null || supply === void 0 ? void 0 : supply.count,
                            };
                        })
                        : response.map(function (order) {
                            var mappedCard = mappedCards
                                ? mappedCards[order.sell.data.token_id ? Number.parseInt(order.sell.data.token_id) : 0]
                                : undefined;
                            var mappedMintPass = mappedMintPasses
                                ? mappedMintPasses[order.sell.data.token_id ? Number.parseInt(order.sell.data.token_id) : 0]
                                : undefined;
                            var mappedSouvenirCard = mappedSouvenirCards
                                ? mappedSouvenirCards[order.sell.data.token_id ? Number.parseInt(order.sell.data.token_id) : 0]
                                : undefined;
                            var price = parseCurrencyQuantity(order.buy.data.quantity_with_fees, order.buy.data.token_address);
                            var shredPreview = cardShredData
                                ? cardShredData.mpCardWithDisenchantPreviewFindMany.find(function (data) { var _a; return ((_a = data.card.tokenId) === null || _a === void 0 ? void 0 : _a.toString()) === order.sell.data.token_id; })
                                : undefined;
                            var supply = supplyData
                                ? supplyData.mpCardSupplyFindByTokenIds.cards.find(function (data) { var _a; return ((_a = data.tokenId) === null || _a === void 0 ? void 0 : _a.toString()) === order.sell.data.token_id; })
                                : undefined;
                            return {
                                order: order,
                                card: mappedCard,
                                mintPass: mappedMintPass,
                                souvenirCard: mappedSouvenirCard,
                                isPendingBurn: false,
                                price: price,
                                shredPreview: shredPreview
                                    ? {
                                        stonesCount: shredPreview.disenchantPreview.stoneEternal,
                                        triselsCount: shredPreview.disenchantPreview.freeGemsCount,
                                    }
                                    : undefined,
                                supply: supply === null || supply === void 0 ? void 0 : supply.count,
                            };
                        });
                    result = __spreadArray(__spreadArray([], result, true), newDetailedOrders, true);
                    return [2 /*return*/, {
                            orders: getSortedOrdersByUsdPrice(result, orderBy, direction),
                            cursors: {
                                cta: ctaTokenResponse ? ctaTokenResponse.cursor : undefined,
                                usdc: usdcResponse ? usdcResponse.cursor : undefined,
                            },
                            remainings: {
                                cta: ctaTokenResponse ? ctaTokenResponse.remaining : (remainings === null || remainings === void 0 ? void 0 : remainings.cta) || 0,
                                usdc: usdcResponse ? usdcResponse.remaining : (remainings === null || remainings === void 0 ? void 0 : remainings.usdc) || 0,
                            },
                        }];
            }
        });
    });
}
export function getSortedOrdersByUsdPrice(orders, orderBy, direction) {
    return orders.sort(function (orderA, orderB) {
        if (orderBy === 'updated_at') {
            var result = moment(orderA.order.updated_timestamp).diff(orderB.order.updated_timestamp);
            return direction === SortDirection.ASC ? result : result * -1;
        }
        if (orderBy === 'buy_quantity_with_fees') {
            if (!orderA.price.usd || !orderB.price.usd)
                return 0;
            var result = orderA.price.usd.value - orderB.price.usd.value;
            return direction === SortDirection.ASC ? result : result * -1;
        }
        return 0;
    });
}
export function getAssetFloorPrice(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, type, metadata) {
    return __awaiter(this, void 0, Promise, function () {
        var auxiliaryFee, sellMetadata, responses, _a, _b, _c, order, floorPrice, _i, responses_1, response, price, tokenId, cardData, _d, cardShredData, _e, supplyData, _f, mintPassData, _g, souvenirCardData, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    auxiliaryFee = fees.buyer > 0
                        ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                        : {};
                    sellMetadata = {
                        ian: metadata.ian ? [metadata.ian] : undefined,
                        id: metadata.id ? [metadata.id] : undefined,
                        element: metadata.element ? [metadata.element] : undefined,
                        rank: metadata.ranks ? metadata.ranks.map(function (rank) { return rank.toString(); }) : undefined,
                        grade: metadata.grades ? metadata.grades : undefined,
                        foil: metadata.foil !== undefined ? [metadata.foil] : undefined,
                        name: metadata.name !== undefined ? [metadata.name] : undefined,
                    };
                    _b = (_a = Promise).all;
                    _c = [queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: appEnv.blockchain.collectionAddress, sellMetadata: JSON.stringify(sellMetadata), buyTokenAddress: appEnv.ctaTokenAddress, pageSize: 1, orderBy: 'buy_quantity_with_fees', direction: 'asc', status: 'active', includeFees: true }, auxiliaryFee));
                        })];
                    return [4 /*yield*/, queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: appEnv.blockchain.collectionAddress, sellMetadata: JSON.stringify(sellMetadata), buyTokenAddress: usdcAddress, pageSize: 1, orderBy: 'buy_quantity_with_fees', direction: 'asc', status: 'active', includeFees: true }, auxiliaryFee));
                        })];
                case 1: return [4 /*yield*/, _b.apply(_a, [_c.concat([
                            _j.sent()
                        ])])];
                case 2:
                    responses = _j.sent();
                    for (_i = 0, responses_1 = responses; _i < responses_1.length; _i++) {
                        response = responses_1[_i];
                        if (response.result.length > 0) {
                            price = parseCurrencyQuantity(response.result[0].buy.data.quantity_with_fees, response.result[0].buy.data.token_address);
                            if (price.base && price.usd && ((floorPrice === null || floorPrice === void 0 ? void 0 : floorPrice.usd) === undefined || price.usd.value < floorPrice.usd.value)) {
                                order = response.result[0];
                                floorPrice = price;
                            }
                        }
                    }
                    tokenId = order && order.sell.data.token_id ? Number.parseInt(order.sell.data.token_id) : undefined;
                    if (!(tokenId && type === TokenType.CARD)) return [3 /*break*/, 4];
                    return [4 /*yield*/, gqlSdk.CardFindManyByTokenId({ input: { tokenIds: [tokenId] } })];
                case 3:
                    _d = _j.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _d = undefined;
                    _j.label = 5;
                case 5:
                    cardData = _d;
                    if (!(tokenId && cardData)) return [3 /*break*/, 7];
                    return [4 /*yield*/, gqlSdk.MpCardWithDisenchantPreviewFindMany({ input: { tokenIds: [tokenId] } })];
                case 6:
                    _e = _j.sent();
                    return [3 /*break*/, 8];
                case 7:
                    _e = undefined;
                    _j.label = 8;
                case 8:
                    cardShredData = _e;
                    if (!(tokenId && cardData)) return [3 /*break*/, 10];
                    return [4 /*yield*/, gqlSdk.MpCardSupplyFindByTokenIds({ input: { tokenIds: [tokenId] } })];
                case 9:
                    _f = _j.sent();
                    return [3 /*break*/, 11];
                case 10:
                    _f = undefined;
                    _j.label = 11;
                case 11:
                    supplyData = _f;
                    if (!(tokenId && type === TokenType.MINT_PASS)) return [3 /*break*/, 13];
                    return [4 /*yield*/, gqlSdk.MintPassFindManyByTokenId({ input: { tokenIds: [tokenId] } })];
                case 12:
                    _g = _j.sent();
                    return [3 /*break*/, 14];
                case 13:
                    _g = undefined;
                    _j.label = 14;
                case 14:
                    mintPassData = _g;
                    if (!(tokenId && type === TokenType.SOUVENIR_CARD)) return [3 /*break*/, 16];
                    return [4 /*yield*/, gqlSdk.SouvenirCardFindManyByTokenId({ input: { tokenIds: [tokenId] } })];
                case 15:
                    _h = _j.sent();
                    return [3 /*break*/, 17];
                case 16:
                    _h = undefined;
                    _j.label = 17;
                case 17:
                    souvenirCardData = _h;
                    return [2 /*return*/, order && floorPrice
                            ? {
                                order: order,
                                card: cardData ? cardData.cardFindManyByTokenId[0] : undefined,
                                mintPass: mintPassData ? mintPassData.mintPassFindManyByTokenId[0] : undefined,
                                souvenirCard: souvenirCardData ? souvenirCardData.souvenirCardFindManyByTokenId[0] : undefined,
                                isPendingBurn: false,
                                price: floorPrice,
                                shredPreview: cardShredData && cardShredData.mpCardWithDisenchantPreviewFindMany[0]
                                    ? {
                                        stonesCount: cardShredData.mpCardWithDisenchantPreviewFindMany[0].disenchantPreview.stoneEternal,
                                        triselsCount: cardShredData.mpCardWithDisenchantPreviewFindMany[0].disenchantPreview.freeGemsCount,
                                    }
                                    : undefined,
                                supply: supplyData && supplyData.mpCardSupplyFindByTokenIds.cards[0]
                                    ? supplyData.mpCardSupplyFindByTokenIds.cards[0].count
                                    : undefined,
                            }
                            : undefined];
            }
        });
    });
}
export function getAssetSplittedFloorPrices(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, type, metadata) {
    return __awaiter(this, void 0, Promise, function () {
        var auxiliaryFee, sellMetadata, responses, _a, _b, _c, result, i, order, price, tokenId, cardData, _d, cardShredData, _e, supplyData, _f, mintPassData, _g, souvenirCardData, _h, resultedOrder;
        var _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    auxiliaryFee = fees.buyer > 0
                        ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                        : {};
                    sellMetadata = {
                        ian: metadata.ian ? [metadata.ian] : undefined,
                        id: metadata.id ? [metadata.id] : undefined,
                        element: metadata.element ? [metadata.element] : undefined,
                        rank: metadata.ranks ? metadata.ranks.map(function (rank) { return rank.toString(); }) : undefined,
                        grade: metadata.grades ? metadata.grades : undefined,
                        foil: metadata.foil !== undefined ? [metadata.foil] : undefined,
                        name: metadata.name !== undefined ? [metadata.name] : undefined,
                    };
                    _b = (_a = Promise).all;
                    _c = [queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: appEnv.blockchain.collectionAddress, sellMetadata: JSON.stringify(sellMetadata), buyTokenAddress: appEnv.ctaTokenAddress, pageSize: 1, orderBy: 'buy_quantity_with_fees', direction: 'asc', status: 'active', includeFees: true }, auxiliaryFee));
                        })];
                    return [4 /*yield*/, queue.add(function () {
                            return imxClient.listOrders(__assign({ sellTokenAddress: appEnv.blockchain.collectionAddress, sellMetadata: JSON.stringify(sellMetadata), buyTokenAddress: usdcAddress, pageSize: 1, orderBy: 'buy_quantity_with_fees', direction: 'asc', status: 'active', includeFees: true }, auxiliaryFee));
                        })];
                case 1: return [4 /*yield*/, _b.apply(_a, [_c.concat([
                            _k.sent()
                        ])])];
                case 2:
                    responses = _k.sent();
                    result = (_j = {},
                        _j[CurrencyTokenSymbol.CTA] = undefined,
                        _j[CurrencyTokenSymbol.USDC] = undefined,
                        _j);
                    i = 0;
                    _k.label = 3;
                case 3:
                    if (!(i < responses.length)) return [3 /*break*/, 20];
                    order = responses[i].result[0];
                    if (!order)
                        return [3 /*break*/, 19];
                    price = parseCurrencyQuantity(order.buy.data.quantity_with_fees, order.buy.data.token_address);
                    tokenId = order && order.sell.data.token_id ? Number.parseInt(order.sell.data.token_id) : undefined;
                    if (!(tokenId && type === TokenType.CARD)) return [3 /*break*/, 5];
                    return [4 /*yield*/, gqlSdk.CardFindManyByTokenId({ input: { tokenIds: [tokenId] } })];
                case 4:
                    _d = _k.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _d = undefined;
                    _k.label = 6;
                case 6:
                    cardData = _d;
                    if (!(tokenId && cardData)) return [3 /*break*/, 8];
                    return [4 /*yield*/, gqlSdk.MpCardWithDisenchantPreviewFindMany({ input: { tokenIds: [tokenId] } })];
                case 7:
                    _e = _k.sent();
                    return [3 /*break*/, 9];
                case 8:
                    _e = undefined;
                    _k.label = 9;
                case 9:
                    cardShredData = _e;
                    if (!(tokenId && cardData)) return [3 /*break*/, 11];
                    return [4 /*yield*/, gqlSdk.MpCardSupplyFindByTokenIds({ input: { tokenIds: [tokenId] } })];
                case 10:
                    _f = _k.sent();
                    return [3 /*break*/, 12];
                case 11:
                    _f = undefined;
                    _k.label = 12;
                case 12:
                    supplyData = _f;
                    if (!(tokenId && type === TokenType.MINT_PASS)) return [3 /*break*/, 14];
                    return [4 /*yield*/, gqlSdk.MintPassFindManyByTokenId({ input: { tokenIds: [tokenId] } })];
                case 13:
                    _g = _k.sent();
                    return [3 /*break*/, 15];
                case 14:
                    _g = undefined;
                    _k.label = 15;
                case 15:
                    mintPassData = _g;
                    if (!(tokenId && type === TokenType.SOUVENIR_CARD)) return [3 /*break*/, 17];
                    return [4 /*yield*/, gqlSdk.SouvenirCardFindManyByTokenId({ input: { tokenIds: [tokenId] } })];
                case 16:
                    _h = _k.sent();
                    return [3 /*break*/, 18];
                case 17:
                    _h = undefined;
                    _k.label = 18;
                case 18:
                    souvenirCardData = _h;
                    resultedOrder = order && price
                        ? {
                            order: order,
                            card: cardData ? cardData.cardFindManyByTokenId[0] : undefined,
                            mintPass: mintPassData ? mintPassData.mintPassFindManyByTokenId[0] : undefined,
                            souvenirCard: souvenirCardData ? souvenirCardData.souvenirCardFindManyByTokenId[0] : undefined,
                            isPendingBurn: false,
                            price: price,
                            shredPreview: cardShredData && cardShredData.mpCardWithDisenchantPreviewFindMany[0]
                                ? {
                                    stonesCount: cardShredData.mpCardWithDisenchantPreviewFindMany[0].disenchantPreview.stoneEternal,
                                    triselsCount: cardShredData.mpCardWithDisenchantPreviewFindMany[0].disenchantPreview.freeGemsCount,
                                }
                                : undefined,
                            supply: supplyData && supplyData.mpCardSupplyFindByTokenIds.cards[0]
                                ? supplyData.mpCardSupplyFindByTokenIds.cards[0].count
                                : undefined,
                        }
                        : undefined;
                    if (i === 0)
                        result[CurrencyTokenSymbol.CTA] = resultedOrder;
                    if (i === 1)
                        result[CurrencyTokenSymbol.USDC] = resultedOrder;
                    _k.label = 19;
                case 19:
                    i++;
                    return [3 /*break*/, 3];
                case 20: return [2 /*return*/, result];
            }
        });
    });
}
